/**
 * Validates a US zip code.
 * Accepts 5-digit format (e.g., "12345") or ZIP+4 format (e.g., "12345-6789")
 * @param {string} zip - The zip code to validate
 * @returns {boolean} - True if the zip code is valid, false otherwise
 */
export const validateZipCode = (zip) => {
    if (!zip) return true; // Allow empty values
    const zipRegex = /^\d{5}(-\d{4})?$/;
    return zipRegex.test(zip);
};
